import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';

// Scroll Component
import ScrollToTop from './components/ScrollToTop';
import TokenTracker from './components/TokenTracker';
import DefaultLayout from './components/Layout/DefaultLayout';

const App = () => {
    return <BrowserRouter>
        <ScrollToTop />
        <TokenTracker />
        <Routes>
            <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
    </BrowserRouter>
}

export default App;